import { Box, Link, Stack, Tooltip, Typography } from "@mui/material";
import { FC } from "react";
import { Mail } from "@mui/icons-material";
import CxEmployeeAvatar, { AvatarSize } from "@components/CxEmployeeAvatar";
import { alpha } from "@mui/material/styles";

interface ShiTeamMemberProps {
  shiEmployeeId?: string;
  fullName?: string;
  customerFacingTitle?: string;
  customerFacingEmailAddress?: string;
}

const ShiTeamMember: FC<ShiTeamMemberProps> = ({
  shiEmployeeId,
  fullName,
  customerFacingTitle,
  customerFacingEmailAddress,
}) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      border={1}
      borderColor="border"
      borderRadius={1}
      p={1}
      pl={1.5}
      gap={2}
    >
      <CxEmployeeAvatar
        entraId={shiEmployeeId ?? ""}
        displayName={fullName}
        photoSize={AvatarSize.medium}
      />
      <Stack spacing={0.5} sx={{ minWidth: 0, flex: 1, overflow: "hidden" }}>
        <Stack
          direction="row"
          spacing={1}
          alignItems="baseline"
          sx={{ minWidth: 0 }}
        >
          <Typography
            variant="subtitle2"
            noWrap
            title={fullName ?? ""}
            sx={{ flexShrink: 0 }}
          >
            {fullName}
          </Typography>
          {customerFacingTitle && (
            <Tooltip title={customerFacingTitle}>
              <Typography
                variant="caption"
                color="text.secondary"
                noWrap
                sx={{ flexShrink: 1, minWidth: 0 }}
              >
                {customerFacingTitle}
              </Typography>
            </Tooltip>
          )}
        </Stack>
        {customerFacingEmailAddress && (
          <Link
            variant="caption"
            sx={[
              {
                fontWeight: "regular",
                textDecoration: "none",
                textTransform: "lowercase",
                display: "flex",
                alignItems: "center",
                alignSelf: "flex-start",
                gap: 1,
                borderRadius: "8px",
                padding: "2px 4px 2px 0",
                margin: "-2px 0",
                transition: "background-color 0.2s, opacity 0.2s",
              },
              (theme) =>
                theme.applyStyles("light", {
                  "&:focus-visible": {
                    outline: "none",
                    backgroundColor: alpha(
                      theme.palette.primary.dark,
                      theme.palette.action.focusOpacity,
                    ),
                  },
                }),
              (theme) =>
                theme.applyStyles("dark", {
                  "&:focus-visible": {
                    outline: "none",
                    backgroundColor: alpha(
                      theme.palette.primary.light,
                      theme.palette.action.focusOpacity,
                    ),
                  },
                }),
            ]}
            href={`mailto:${customerFacingEmailAddress}`}
          >
            <Mail fontSize="small" color="action" />
            {customerFacingEmailAddress}
          </Link>
        )}
      </Stack>
    </Box>
  );
};

export default ShiTeamMember;
